var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C9.029 2 5 6.029 5 11C5 15.971 9.029 20 14 20C18.971 20 23 15.971 23 11C23 6.029 18.971 2 14 2ZM14 4C17.866 4 21 7.134 21 11C21 14.866 17.866 18 14 18C10.134 18 7 14.866 7 11C7.004 7.136 10.136 4.004 14 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11.0044C28.002 7.29138 26.525 3.73038 23.895 1.10938L22.481 2.52337C27.176 7.19637 27.193 14.7914 22.519 19.4854C17.846 24.1804 10.251 24.1974 5.55698 19.5234C5.54398 19.5114 5.53098 19.4984 5.51898 19.4854L4.10498 20.8994C6.72598 23.5294 10.287 25.0064 14 25.0044V28.0044H9.99998V30.0044H20V28.0044H16V24.8444C22.88 23.8474 27.988 17.9564 28 11.0044Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.ee4efa0595893185aa5052d444ff8939.svg";
export { ForwardRef as ReactComponent };